// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PartnerPenaltiesApiModel from "../api-model/PartnerPenaltiesApiModel.bs.js";

function apiModelToState(res) {
  return List.map((function (penalty) {
                var date = penalty.deleted_at;
                return {
                        penalty_id: penalty.id,
                        order_crn: Belt_Option.getWithDefault(penalty.crn, "Not Found"),
                        msisdn: Belt_Option.getWithDefault(penalty.msisdn, "Not Found"),
                        driver_name: Belt_Option.getWithDefault(penalty.driver_name, "Not Found"),
                        engagement_type: penalty.engagement_type,
                        date: Timestamp$Catalyst.make(penalty.date),
                        penalty_type: Belt_Option.getWithDefault(penalty.penalty_type, "Not Found"),
                        amount: Currency.toCurrency(penalty.amount),
                        applied_at: Timestamp$Catalyst.make(penalty.applied_at),
                        applied_by: Belt_Option.getWithDefault(penalty.applied_by, "Auto"),
                        is_waived_off: penalty.is_waived_off,
                        category: penalty.category,
                        is_deleted: penalty.is_deleted,
                        deleted_at: date !== undefined ? Caml_option.some(Timestamp$Catalyst.make(date)) : undefined,
                        deleted_by: penalty.deleted_by,
                        deletion_comment: penalty.comment
                      };
              }), res);
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PartnerPenaltiesApiModel.t_decode(json), "PartnerPenaltyListEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
